import VAppLoader from './VAppLoader.vue';

export { VAppLoader };
export default VAppLoader;
